/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import { useState, useEffect } from "react";
import { FormModel } from "../FormModel/FormModel";

/**
 * Uses form model and returns model state
 *
 * @param model Form model instance
 */
export function useFormModel(model: FormModel) {

	const [ state, setState ] = useState(() => model.getState());

	useEffect(() => {

		const handleUpdate = () => {
			setState(model.getState());
		};

		model.on("update", handleUpdate);
		model.getNameField().on("update", handleUpdate);
		model.getHeaderTitleField().on("update", handleUpdate);

		handleUpdate();

		return () => {
			model.off("update", handleUpdate);
			model.getNameField().off("update", handleUpdate);
			model.getHeaderTitleField().off("update", handleUpdate);
		};

	}, [ model ]);

	return state;

}
